import { isExecutive, isOrganizationAdmin, isPlatformExecutive, isProductCollaborator, isProductExecutive, isReportingManager, type Role } from "../session/roles.ts";

export const ADMIN_ONLY_ACCESS: readonly Role[] = [isOrganizationAdmin];

export const ORGANIZATION_PEOPLE_ACCESS: readonly Role[] = [isOrganizationAdmin, isPlatformExecutive];

export const PERFORMANCE_CYCLES_ACCESS: readonly Role[] = [isProductExecutive("wpm"), isProductCollaborator("wpm")];

export const PERFORMANCE_CYCLE_RESULTS_ACCESS: readonly Role[] = [isProductExecutive("wpm"), isReportingManager];

export const PERFORMANCE_CYCLE_DETAILS_ACCESS: readonly Role[] = [...PERFORMANCE_CYCLES_ACCESS, isReportingManager];

export const REVIEWEE_FILTER_OPTIONS_ACCESS: readonly Role[] = [isExecutive, ...PERFORMANCE_CYCLE_DETAILS_ACCESS];
